














































































































































































import { Component, Mixins, Prop, Emit, Watch } from "vue-property-decorator";
import AxiosMixin from "@/mixins/axiosMixin";
import { renderMedicineHtml } from "./medicineTextConverter";

interface ProductDetail {
  product_id: string;
  product_name: string;
  major_heading: string;
  unit: string;
  generic_name: string;
  category: string;
  indications: string;
  dosage: string;
  features: string;
}

export interface MedicineItemView {
  yj_code: string;
  name: string;
  is_generic: boolean;
  unit: string;
  generic_name: string;
  category: string;
  indications: string;
  dosage: string;
  features: string;
  photo_file_name: string;
  products: ProductView[];
}

interface ProductView {
  product_name: string;
  major_heading: string;
  unit: string;
  generic_name: string;
  category: string;
  indications: string;
  dosage: string;
  features: string;
}

@Component
export default class MedicineProductDetailDialog extends Mixins(AxiosMixin) {
  @Prop({ default: false }) value!: boolean;
  @Prop({ default: "" }) productId!: string;

  private internalValue = false;
  private internalProductId = "";
  private product: ProductDetail | null = null;
  private medicines: MedicineItemView[] = [];

  /** アイコン用先頭文字を除いた商品名 */
  get productDisplayName(): string {
    const name = this.product?.product_name || "";
    const lead = name.charAt(0);
    return "●○★◎".includes(lead) ? name.slice(1) : name;
  }

  get productLeadIcon(): string {
    const name = this.product?.product_name || "";
    const lead = name.charAt(0);
    const iconMap: Record<string, string> = {
      "●": "ic_daihyo",
      "○": "ic_kouhatsu_a",
      "★": "ic_shinyaku",
      "◎": "ic_ag_c"
    };
    const icon = iconMap[lead] || "ic_kouhatsu_b";
    return `/images/medicine/icon/${icon}.svg`;
  }

  @Watch("value")
  private onValueChanged(val: boolean) {
    this.internalValue = val;
    if (val && this.productId) {
      this.internalProductId = this.productId;
      this.fetchProductDetail(this.productId);
    }
  }

  @Emit("input")
  private emitInput(val: boolean) {
    return val;
  }

  @Emit("select-medicine")
  private emitSelectMedicine(medicine: MedicineItemView) {
    return medicine;
  }

  private selectMedicine(medicine: MedicineItemView) {
    this.emitSelectMedicine(medicine);
    this.close();
  }

  private renderHtml(text: string): string {
    return renderMedicineHtml(text);
  }

  private onContentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (target.tagName === "A" && target.classList.contains("medicine-ref")) {
      event.preventDefault();
      const productId = target.getAttribute("data-product-id");
      if (productId) {
        this.internalProductId = productId;
        this.fetchProductDetail(productId);
      }
    }
  }

  private close() {
    this.internalValue = false;
    this.emitInput(false);
  }

  private fetchProductDetail(productId: string): void {
    this.product = null;
    this.medicines = [];
    this.postJsonCheck(
      window.base_url + "/api/patient/medicine/product/detail",
      { product_id: productId },
      res => {
        this.product = res.data.product || null;
        this.medicines = res.data.medicines || [];
      }
    );
  }
}
